'use client';

import Button, { type ButtonProps } from '@carvana/ds-button';
import Spinner from '@carvana/ds-spinner';
import cx from 'classnames';
import useSoftpullGatedClick from '~/hooks/flp-rsc/useSoftpullGatedClick';

type OwnProps = Omit<ButtonProps, 'disabled' | 'onClick'> & {
  onClick: () => void;
};

export default function SoftpullMfeButton({
  children,
  className,
  onClick,
  size = 'md',
  variant = 'primary',
  ...props
}: OwnProps) {
  const { handleClick, isWaiting } = useSoftpullGatedClick(onClick);
  const spinnerSize = size === 'md' || size === 'lg' ? 'lg' : 'sm';
  const buttonProps = { ...props, onClick: handleClick };

  return (
    <Button
      className={cx('relative', className)}
      disabled={isWaiting}
      size={size}
      variant={variant}
      {...buttonProps}
    >
      <span className={cx({ invisible: isWaiting })}>{children}</span>
      {isWaiting && (
        // Every DS Button variant falls back to the same light disabled
        // background/text colors, so the spinner should match that
        // regardless of the button's normal (non-disabled) variant.
        <span className="absolute inset-0 flex items-center justify-center">
          <Spinner size={spinnerSize} />
        </span>
      )}
    </Button>
  );
}
